var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _rect4, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderSiteSurveyTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H28V2H24V4ZM24 4.33333V4H22V4.33333H24ZM21 6.33333H22V4.33333H21V6.33333ZM21 9V6.33333H19V9H21ZM31 9H21V11H31V9ZM31 6.33333V9H33V6.33333H31ZM30 6.33333H31V4.33333H30V6.33333ZM28 4V4.33333H30V4H28ZM30 4.33333V4.33333H28C28 5.4379 28.8954 6.33333 30 6.33333V4.33333ZM33 6.33333C33 5.22876 32.1046 4.33333 31 4.33333V6.33333H33ZM31 11C32.1046 11 33 10.1046 33 9H31V9V11ZM19 9C19 10.1046 19.8954 11 21 11V9H21H19ZM21 4.33333C19.8954 4.33333 19 5.22876 19 6.33333H21V6.33333V4.33333ZM22 4.33333V4.33333V6.33333C23.1046 6.33333 24 5.4379 24 4.33333H22ZM28 4V4H30C30 2.89543 29.1046 2 28 2V4ZM24 2C22.8954 2 22 2.89543 22 4H24V4V2Z",
    fill: "#4F7FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18L18.3333 20C19.3747 18.4379 19.9586 17.5621 21 16",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30L18.3333 32C19.3747 30.4379 19.9586 29.5621 21 28",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42L18.3333 44C19.3747 42.4379 19.9586 41.5621 21 40",
    stroke: "#4F7FA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6H40C42.2091 6 44 7.79086 44 10V18M20 6H12C9.79086 6 8 7.79086 8 10V49C8 51.2091 9.79086 53 12 53H40C42.2091 53 44 51.2091 44 49V26.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25V11C40 10.4477 39.5523 10 39 10H13C12.4477 10 12 10.4477 12 11V48C12 48.5523 12.4477 49 13 49H39C39.5523 49 40 48.5523 40 48V33.5",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9641 40.2487L30.7321 45.3109L32.5 38.2487",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 16.5981,
    width: 4,
    height: 25,
    transform: "rotate(30 45 16.5981)",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16.5981L48.4641 18.5981L49.4641 16.866C49.7402 16.3877 49.5764 15.7761 49.0981 15.5L47.366 14.5C46.8877 14.2239 46.2761 14.3877 46 14.866L45 16.5981Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16L36 16",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28L36 28",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20H31",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32H31",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H32",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44H31",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderSiteSurveyTool);
export default __webpack_public_path__ + "static/media/subheader-site-survey-tool.e1be09a33e722dc1c12714ae757cd4d1.svg";
export { ForwardRef as ReactComponent };